export default __webpack_public_path__ + "static/media/newmandelbrot.bef20c55.png";